/*
 * ct-rollo-select — selector propio para el bloque "También disponible" de la ficha.
 * CT 2026-09-21. Sin librerias.
 *
 * QUE REEMPLAZA: el <select> nativo, que mostraba solo "BEIGE / 63" sin precio.
 * Cada fila lleva el nombre del color, el metraje y el precio real de ESE rollo.
 * (v3: la miniatura por fila se saco a pedido de Camilo — ese ancho se lo lleva el nombre, que
 * puede ocupar dos lineas en vez de recortarse con puntos. El color se ve en la FOTO GRANDE del
 * bloque, que ahora cambia con la variante elegida.)
 *
 * 🔑 POR QUE NO ROMPE EL CARRITO: el formulario sigue teniendo el mismo
 * <input type="hidden" name="items[][id]" class="complementary-variant-id"> de siempre.
 * assets/complementary-products.js lee ESE input -su value y sus data-price / data-available-
 * tanto para calcular el total como para agregar al carrito, y ya soportaba el input oculto
 * (era el camino de los productos de una sola variante). Este archivo solo lo actualiza y
 * dispara un evento 'change', que es a lo que ese JS ya estaba escuchando.
 * Por eso la cantidad y "Agregar articulos al carrito" siguen funcionando sin tocar su codigo.
 *
 * 🔑 POR QUE NO RECORRE LAS VARIANTES AL TOCAR: cada opcion lleva SUS datos en sus propios
 * atributos data-*. Elegir es copiar cuatro atributos del boton tocado al input oculto. No hay
 * busqueda, ni filtro, ni recorrido: es O(1). Es la misma leccion del selector de color de la
 * ficha, que es lo que hoy se esta midiendo con ct_inp.
 */
if (!customElements.get('ct-rollo-select')) {
  customElements.define('ct-rollo-select', class CtRolloSelect extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.complementary-variant-id');
      this.disp = this.querySelector('.ct-rollo__disp');
      this.lista = this.querySelector('.ct-rollo__lista');
      if (!this.input || !this.disp || !this.lista) return;   // sin rollos: no hay nada que abrir

      this.opciones = Array.from(this.lista.querySelectorAll('.ct-rollo__opt'));
      this.onDoc = this.cerrarSiAfuera.bind(this);

      this.disp.addEventListener('click', () => this.lista.hidden ? this.abrir() : this.cerrar());
      this.lista.addEventListener('click', e => {
        const b = e.target.closest('.ct-rollo__opt');
        if (b) { this.elegir(b); this.cerrar(); this.disp.focus(); }
      });
      this.lista.addEventListener('keydown', e => this.teclado(e));
      this.disp.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.abrir(); }
      });
      document.addEventListener('click', this.onDoc);
    }

    disconnectedCallback() { document.removeEventListener('click', this.onDoc); }

    abrir() {
      this.lista.hidden = false;
      this.disp.setAttribute('aria-expanded', 'true');
      const sel = this.opciones.find(o => o.getAttribute('aria-selected') === 'true') || this.opciones[0];
      if (sel) sel.focus();
    }

    cerrar() {
      this.lista.hidden = true;
      this.disp.setAttribute('aria-expanded', 'false');
    }

    cerrarSiAfuera(e) {
      if (!this.lista.hidden && !this.contains(e.target)) this.cerrar();
    }

    teclado(e) {
      const i = this.opciones.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i > -1 && i < this.opciones.length - 1) { e.preventDefault(); this.opciones[i + 1].focus(); }
      else if (e.key === 'ArrowUp' && i > 0) { e.preventDefault(); this.opciones[i - 1].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); this.opciones[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); this.opciones[this.opciones.length - 1].focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); this.cerrar(); this.disp.focus(); }
    }

    elegir(b) {
      // Copiar, no buscar. Estos cuatro atributos son lo unico que complementary-products.js lee.
      this.input.value = b.dataset.id;
      this.input.dataset.price = b.dataset.price || '0';
      this.input.dataset.compareAtPrice = b.dataset.compareAtPrice || '';
      this.input.dataset.available = 'true';
      // CT 2026-09-28: metraje del rollo elegido, para el precio por metro y el descuento del título (ct-tambien-desc.js)
      this.input.dataset.cant = b.dataset.cant || '';

      this.opciones.forEach(o => o.setAttribute('aria-selected', o === b ? 'true' : 'false'));

      // CT v3: la foto GRANDE del bloque pasa a ser la de la variante elegida. Si esa variante
      // no tiene imagen propia, se vuelve a la destacada del producto, que quedo guardada en
      // data-ct-fallback. Se busca una sola vez por item, no en cada toque.
      if (this.foto === undefined) {
        const item = this.closest('.complementary__item');
        this.foto = item ? item.querySelector('.ct-rollo__foto') : null;
      }
      if (this.foto) {
        const url = b.dataset.img || this.foto.dataset.ctFallback;
        if (url) {
          this.foto.removeAttribute('srcset');   // si el tema dejo uno, mandaria el srcset y no el src
          this.foto.src = url;
          this.foto.alt = b.dataset.alt || b.dataset.color || '';
        }
      }

      const t = this.disp.querySelector('.ct-rollo__txt'); if (t) t.textContent = b.dataset.color || '';
      // CT 2026-09-28: la unidad es la del botón elegido (m o kg); sin metraje (tarjeta x Metros) no hay nada que mostrar
      const m = this.disp.querySelector('.ct-rollo__met'); if (m) { const u = b.querySelector('.ct-rollo__met'); m.textContent = u ? u.textContent : ''; }
      const p = this.disp.querySelector('.ct-rollo__pre'); if (p) p.textContent = b.dataset.money || '';

      // Lo que hace que el total y el boton se actualicen: el otro JS ya escucha este evento.
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}
